import type { ReactNode } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface EfemGatewayListPanelProps {
  count: number;
  loading?: boolean;
  children: ReactNode;
}

/** Themed left rail for EFEM setup — gateway list with header. */
export function EfemGatewayListPanel({ count, loading, children }: EfemGatewayListPanelProps) {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        height: '100%',
        width: '100%',
        bgcolor: 'transparent',
      }}
    >
      <Box
        sx={{
          px: 1.5,
          py: 1,
          borderBottom: 1,
          borderColor: 'divider',
          flexShrink: 0,
        }}
      >
        <Typography
          variant="caption"
          color="text.secondary"
          fontWeight="bold"
          textTransform="uppercase"
          letterSpacing={0.5}
        >
          Gateways ({count})
        </Typography>
      </Box>
      <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress size={28} />
          </Box>
        ) : (
          children
        )}
      </Box>
    </Box>
  );
}
